"use client";

import { useRef } from "react";
import { ArrowUpRight } from "lucide-react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useGSAP } from "@gsap/react";
gsap.registerPlugin(useGSAP, ScrollTrigger);
const mosaicImages = [{
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1737412/img/IMG_4559.jpg",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1737412/img/IMG_4559.jpg-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1737412/img/IMG_4559.jpg-wvc-sizes",
  alt: "Premium vehicle detailing interior finish",
  className: "md:col-span-6 md:row-span-2 aspect-[4/5]",
  row: 0
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1737412/img/IMG_5088.jpg",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1737412/img/IMG_5088.jpg-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1737412/img/IMG_5088.jpg-wvc-sizes",
  alt: "Close up of automotive paint correction",
  className: "md:col-span-3 aspect-square",
  row: 0
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1737412/img/IMG_5244.jpg",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1737412/img/IMG_5244.jpg-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1737412/img/IMG_5244.jpg-wvc-sizes",
  alt: "Professional ceramic coating application",
  className: "md:col-span-3 md:row-span-2 aspect-[4/5]",
  row: 0
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1737412/img/IMG_4227.jpg",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1737412/img/IMG_4227.jpg-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1737412/img/IMG_4227.jpg-wvc-sizes",
  alt: "Detailed wheel and tire restoration",
  className: "md:col-span-3 aspect-square",
  row: 1
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1737412/img/IMG_5152.jpg",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1737412/img/IMG_5152.jpg-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1737412/img/IMG_5152.jpg-wvc-sizes",
  alt: "Detailing work photo showing interior cleaning",
  className: "md:col-span-3 md:row-span-2 aspect-[4/5]",
  row: 0
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1737412/img/IMG_4875.jpg",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1737412/img/IMG_4875.jpg-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1737412/img/IMG_4875.jpg-wvc-sizes",
  alt: "Detailing work photo showing paint correction",
  className: "md:col-span-3 md:row-span-2 aspect-[4/5]",
  row: 0
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1737412/img/IMG_5134.jpg",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1737412/img/IMG_5134.jpg-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1737412/img/IMG_5134.jpg-wvc-sizes",
  alt: "Detailing work photo showing ceramic coating application",
  className: "md:col-span-3 aspect-square",
  row: 1
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1737412/img/IMG_5243.jpg",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1737412/img/IMG_5243.jpg-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1737412/img/IMG_5243.jpg-wvc-sizes",
  alt: "Detailing work photo showing wheel restoration",
  className: "md:col-span-3 aspect-square",
  row: 1
}];
export default function Showroom() {
  const container = useRef<HTMLElement>(null);
  useGSAP(() => {
    const el = container.current;
    if (!el) return;
    const mm = gsap.matchMedia();
    mm.add("(prefers-reduced-motion: no-preference)", () => {
      gsap.set(".studio-eyebrow", {
        y: 16
      });
      gsap.set(".studio-heading", {
        y: 32
      });
      gsap.set(".studio-support", {
        y: 20
      });
      gsap.to(".studio-eyebrow", {
        opacity: 1,
        y: 0,
        duration: 0.9,
        ease: "power3.out",
        scrollTrigger: {
          trigger: el,
          start: "top 85%",
          once: true
        }
      });
      gsap.to(".studio-heading", {
        opacity: 1,
        y: 0,
        duration: 1.1,
        delay: 0.1,
        ease: "power3.out",
        scrollTrigger: {
          trigger: el,
          start: "top 85%",
          once: true
        }
      });
      gsap.to(".studio-support", {
        opacity: 1,
        y: 0,
        duration: 0.9,
        delay: 0.25,
        ease: "power3.out",
        scrollTrigger: {
          trigger: el,
          start: "top 85%",
          once: true
        }
      });
      [0, 1, 2].forEach(rowIdx => {
        const rowSelector = `.mosaic-row-${rowIdx}`;
        gsap.set(rowSelector, {
          y: 40
        });
        gsap.to(rowSelector, {
          opacity: 1,
          y: 0,
          duration: 0.9,
          stagger: 0.12,
          ease: "power3.out",
          scrollTrigger: {
            trigger: `.mosaic-anchor-${rowIdx}`,
            start: "top 88%",
            once: true
          }
        });
      });
    });
    mm.add("(prefers-reduced-motion: reduce)", () => {
      gsap.set([".studio-eyebrow", ".studio-heading", ".studio-support", ".mosaic-row-0", ".mosaic-row-1", ".mosaic-row-2"], {
        opacity: 1,
        y: 0
      });
    });
    const refresh = () => ScrollTrigger.refresh();
    requestAnimationFrame(refresh);
    if (document.readyState === "complete") refresh();else window.addEventListener("load", refresh, {
      once: true
    });
    document.fonts?.ready.then(refresh);
  }, {
    scope: container
  });
  return <section data-section-id="28588" id="the-showroom-la-sala-de-exhibición" ref={container} className="relative bg-background text-foreground py-32 md:py-44 overflow-hidden">
      <div aria-hidden="true" className="pointer-events-none absolute left-1/2 top-1/3 -translate-x-1/2 -translate-y-1/2 h-[60vw] w-[60vw] max-w-[720px] max-h-[720px] rounded-lg opacity-40 blur-3xl" style={{
      background: "radial-gradient(circle, hsl(41 62% 62% / 0.14) 0%, transparent 60%)"
    }} />

      <div className="relative mx-auto max-w-[1440px] px-6 md:px-12">
        <div className="mx-auto max-w-[720px] text-center mb-16 md:mb-24">
          <div className="studio-eyebrow text-xs md:text-sm font-medium uppercase font-default" style={{
          opacity: 0,
          letterSpacing: "0.28em",
          color: "var(--muted-foreground)"
        }}>
            Gallery
          </div>
          <h2 className="studio-heading font-serif mt-6 text-4xl md:text-6xl lg:text-7xl leading-[1.02]" style={{
          opacity: 0,
          letterSpacing: "-0.015em",
          color: "var(--foreground)"
        }}>
            Precision,{" "}
            <em className="italic" style={{
            color: "var(--primary)",
            fontStyle: "italic"
          }}>
              refined
            </em>{" "}
            daily.
          </h2>
          <p className="studio-support mt-6 md:mt-8 text-base md:text-lg font-default" style={{
          opacity: 0,
          color: "var(--muted-foreground)",
          lineHeight: 1.55
        }}>
            See the elite results we deliver to your home or office.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-6">
          <div className="mosaic-anchor-0 absolute w-px h-px pointer-events-none" />
          <div className="mosaic-anchor-1 absolute w-px h-px pointer-events-none" />
          <div className="mosaic-anchor-2 absolute w-px h-px pointer-events-none" />

          {mosaicImages.map((image, i) => <figure key={i} data-index={i} className={`mosaic-row-${image.row} group relative overflow-hidden rounded-xl aspect-[4/5] ${image.className}`} style={{
          opacity: 0,
          backgroundColor: "var(--card)",
          minHeight: "clamp(250px, 45vh, 600px)"
        }}>
              <img src={image.src} data-wvc-srcset={image.srcset} data-wvc-sizes={image.sizes} alt={image.alt} loading="lazy" decoding="async" className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105" />

              <div aria-hidden="true" className="absolute inset-x-0 bottom-0 h-1/2 transition-opacity duration-500" style={{
            background: "linear-gradient(to top, hsl(258 18% 6% / 0.55), transparent)"
          }} />

              <div aria-hidden="true" className="pointer-events-none absolute inset-0 opacity-0 transition-opacity duration-500 group-hover:opacity-100" style={{
            boxShadow: "inset 0 0 80px 0 hsl(41 62% 62% / 0.2)"
          }} />

              <div className="absolute right-4 top-4 flex h-10 w-10 items-center justify-center rounded-lg border transition-all duration-300 md:opacity-0 md:group-hover:opacity-100" style={{
            borderColor: "var(--primary)",
            color: "var(--primary)",
            backgroundColor: "hsl(258 18% 6% / 0.35)",
            backdropFilter: "blur(6px)"
          }}>
                <ArrowUpRight className="h-4 w-4" strokeWidth={1.25} />
              </div>
            </figure>)}
        </div>
      </div>
    </section>;
}